// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"745e9f22ee548b44b7d5","524":"d4d31d74eb102411cfb0","927":"5516dbc736a887210c85"}[chunkId] + ".css";
};